package com.tixforgigs.common.core.models.embed

import kotlinx.serialization.Serializable

@OptIn(ExperimentalJsExport::class)
@Serializable
data class PostMessageEmbedNavigateDTO(
  val embedPathToNavigate: String
)
